module.exports = __webpack_public_path__ + "img/slide2.d66d7d33.png";